import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyNotice() {
  const navigate = useNavigate();

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      maxWidth: '700px',
      margin: `${window.innerWidth <= 768 ? '0 auto' : '40px auto'}`,
      fontFamily: 'sans-serif',
      color: '#333'
    }}>
      <h2 style={{ color: '#000000ff' }}>Privacy Notice</h2>
      <p>
        This application uses your device's webcam to take photos during a photo booth session.
        All images are captured <strong>locally</strong> and are <strong>not uploaded, stored, or shared</strong> unless you explicitly choose to do so.
      </p>
      <ul style={{ paddingLeft: '20px', listStyleType: 'none' }}>
        <li>📷 Photos are temporarily stored in your browser’s memory during the session.</li>
        <li>🔒 No personal data is collected, stored, or transmitted.</li>
        <li>❌ Closing or refreshing the app clears all captured images.</li>
      </ul>
      <p>
        By using this app, you consent to the use of your webcam for photo capture during the active session.
      </p>

      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#000000ff',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        ← Back
      </button>
    </div>
  );
}

export default PrivacyNotice;